/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import BigNumber from 'bignumber.js';
import { QRCodeSVG } from 'qrcode.react';

import { createUseStyles, useTheme } from '../palette';
import decorate from '../common/utils/decorate';
import * as math from '../common/utils/math';
import * as convert from '../common/utils/convert';
import { loadScript, submitForm } from '../common/utils/async';
import * as storage from '../common/utils/storage';
import usePrint from '../common/hooks/usePrint';
import NumberFormat from '../common/components/NumberFormat';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Button from '../ui/Button';
import Card from '../ui/Card';
import Checkbox from '../ui/Checkbox';
import Divider from '../ui/Divider';
import Grid from '../ui/Grid';
import Icon from '../ui/Icon';
import Logo from '../ui/Logo';
import Skeleton from '../ui/Skeleton';
import Text from '../ui/Text';
import TextInput from '../ui/TextInput';

import Query from './Query';
import AgreementList from './AgreementList';


const ZERO = BigNumber(0);
const HUNDRED = BigNumber(100);
const HUNDREDTH = BigNumber(0.01);
const VOUCHER_MASK = '####-####-####-####';


const useStyles = createUseStyles((theme) => ({
  currencyAdornment: {
    marginLeft: 10
  },
  
  preliminarySkeleton: {
    width: 150
  }
}));

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;
    
    static decorateWith = {
      theme: useTheme,
      classes: useStyles,
      print: usePrint
    };
    
    static propTypes = {};
    
    static defaultProps = {};
    
    constructor(props) {
      super(props);
      
      this.state = {
        requestInfo: undefined,
        submit: false,
        error: null,
        agreementsArticles: undefined,
        agreementsGoods: undefined,
        data: undefined
      };
    }
    
    paymentRequest = () => {
      const {
        paymentInfo,
        
        onNextPage
      } = this.props;
      
      const {
        shop,
        site,
        currency,
        documents,
        group_order,
        
        apiRequest
      } = this.context;
      
      const { submit } = this.state;
      
      if (!paymentInfo || !paymentInfo.scenario || submit) return;
      
      const queue = [];
      
      paymentInfo.scenario.rules.forEach((ruleItem) =>
        ruleItem.methodList.forEach((methodItem) => {
          if (!methodItem.paymentState.value[0].isZero()) {
            queue.push({
              id: methodItem.id,
              value: methodItem.paymentState.value[0]
            });
          }
        })
      );
      
      this.setState((state) => ({ ...state, submit: true }));
      
      apiRequest('money/payment/request', {
        shop,
        site,
        currency,
        documents,
        group_order,
        
        scenario: paymentInfo.scenario.id,
        queue
      })
        .then((requestInfo) => {
          this.setState((state) => ({ ...state, requestInfo, error: null }));
          
          onNextPage(requestInfo);
        })
        .catch((error) =>
          this.setState((state) => ({ ...state, requestInfo: null, error }))
        )
        .finally((error) =>
          this.setState((state) => ({ ...state, submit: false }))
        );
    };
    
    startRequest = () => {
      const { onNextPage } = this.props;
      
      const { apiRequest } = this.context;
      
      const { requestInfo, submit } = this.state;
      
      if (!requestInfo || submit) return;
      
      if (!requestInfo.process) {
        onNextPage();
        
        return;
      }
      
      this.setState((state) => ({ ...state, startSent: true }));
      
      if (!requestInfo.process.protection) {
        setTimeout(() => this.processRequest(), 1);
        
        return;
      }
      
      this.setState((state) => ({ ...state, submit: true }));
      
      apiRequest('client/security/start', { type: 'finop' })
        .then((protectionData) => {
          if (protectionData.mode === 'none') {
            protectionData = null;
            
            this.setState((state) => {
              setTimeout(() => this.processRequest(), 1);
              
              return {
                ...state,
                
                protectionData: null,
                protectionValue: '',
                error: null
              };
            });
          } else {
            this.setState((state) => ({
              ...state,
              
              protectionData,
              protectionValue: '',
              error: null
            }));
          }
        })
        .catch((error) =>
          this.setState((state) => ({
            ...state,
            
            protectionData: null,
            protectionValue: '',
            error
          }))
        )
        .finally((error) =>
          this.setState((state) => ({ ...state, submit: false }))
        );
    };
    
    processRequest = (confirm) => {
      const { onNextPage } = this.props;
      
      const {
        shop,
        site,
        currency,
        request,
        requestSuccessUrl,
        requestErrorUrl,
        referralParent,
        
        apiRequest
      } = this.context;
      
      const { requestInfo, submit, data } = this.state;
      
      if (!request || !requestInfo || submit) return;
      
      this.setState((state) => ({ ...state, submit: true }));
      
      apiRequest('money/payment/start', {
        shop,
        site,
        currency,
        id: request,
        confirm,
        data,
        
        parent: referralParent || null,
        phone: storage.get('SMP') || null,
        
        visitor_success_url: requestSuccessUrl,
        visitor_error_url: requestErrorUrl,
        visitor_screen_width: window.outerWidth,
        visitor_screen_height: window.outerHeight
      })
        .then((requestInfo) => {
          this.setState((state) => ({ ...state, requestInfo, error: null }));
          
          if (requestInfo.process) {
            if (requestInfo.process?.type) {
              const { id, type, data } = requestInfo.process;
              
              if (type === 'quick') {
                this.setState((state) => {
                  setTimeout(() => this.processRequest(id), 1);
                  
                  return { ...state, submit: false };
                });
              } else if (type === 'get') {
                window.location.assign(data?.link);
              } else if (type === 'post') {
                submitForm('post', data?.link, data?.param);
              } else if (type === 'script') {
                loadScript(data?.load)
                  .then(() => {
                    const clickFunc = new Function(
                      'oncomplete',
                      'onclose',
                      String(data?.click || '')
                    );
                    
                    clickFunc(
                      // oncomplete
                      () => {
                        this.setState((state) => {
                          setTimeout(() => this.processRequest(id), 1);
                          
                          return { ...state, submit: false };
                        });
                      },
                      
                      // onclose
                      () =>
                        this.setState((state) => ({ ...state, submit: false }))
                    );
                  })
                  .catch((e) => {
                    console.error(e);

                    this.setState((state) => ({
                      ...state,
                      submit: false,
                      error: e
                    }));
                  });
              } else if (type === 'voucher') {
                if (data.prepare) {
                  this.setState((state) => {
                    setTimeout(() => this.processRequest(id), 1);
                    
                    return { ...state, submit: false };
                  });
                } else {
                  this.setState((state) => ({ ...state, submit: false }));
                }
              } else if (type === 'receipt') {
                this.setState((state) => ({ ...state, submit: false }));
              } else {
                this.setState((state) => ({
                  ...state,
                  submit: false,
                  error: { message: 'Unknown payment type: ' + type }
                }));
              }
            }
          } else {
            this.setState((state) => ({ ...state, submit: false }));

            onNextPage();
          }
        })
        .catch((error) =>
          this.setState((state) => ({ ...state, submit: false, error }))
        );
    };
    
    loadPaymentInfo = async () => {
      const { setPaymentInfo } = this.props;
      
      const {
        shop,
        site,
        currency,
        documents,
        group_order,
        
        langString,
        priceFormat,
        apiRequest,
        apiGetClientTokenGenerate,
        apiGetClientVisitor,
        apiGetPortalArticle
      } = this.context;
      
      try {
        const paymentInfo = await apiRequest('money/payment/info', {
          shop,
          site,
          currency,
          documents,
          group_order
        });

        paymentInfo.value = convert.toBigNumber(paymentInfo.value);
        paymentInfo.paid = convert.toBigNumber(paymentInfo.paid);

        paymentInfo.goods?.forEach(
          (goodsItem) =>
            (goodsItem.value = convert.toBigNumber(goodsItem.value))
        );
        
        if (paymentInfo.group_order?.targets?.length) {
          const token = await apiGetClientTokenGenerate();
          
          await Promise.all(
            paymentInfo.group_order.targets.map(async (target) => {
              target.payment = convert.toBigNumber(target.payment);
              
              if (target.check)
                target.info = (await apiGetClientVisitor(target.id, { token }))[
                  target.id
                ];
            })
          );
        }
        
        if (paymentInfo.agreements?.goods?.length) {
          paymentInfo.agreements.goods = await apiGetPortalArticle(
            paymentInfo.agreements.goods,
            { fields: 'id,title,title2,link,content' }
          );
        }
        
        if (paymentInfo.agreements?.articles?.length) {
          paymentInfo.agreements.articles = await apiGetPortalArticle(
            paymentInfo.agreements.articles,
            { fields: 'id,title,title2,link,content' }
          );
        }
        
        if (paymentInfo.scenarios?.length) {
          paymentInfo.scenarios = paymentInfo.scenarios
            .filter((scenario) => scenario.rules?.length)
            .map((scenario) => {
              scenario = { ...scenario, methodQueue: [] };
              
              const used = new Set();
              
              scenario.rules = scenario.rules.map((rule) => {
                rule = {
                  ...rule,
                  
                  value: [
                    convert.toBigNumber(rule.value?.[0]),
                    convert.toBigNumber(rule.value?.[1], paymentInfo.value)
                  ],
                  
                  methodList: []
                };
                
                paymentInfo.methods?.forEach((method) => {
                  if (used.has(method.id)) return;
                  
                  if (!Array.isArray(rule.methods)
                      || rule.methods.indexOf(method.id) < 0)
                    return;
                  
                  const methodItem = {
                    ...method,
                    
                    rule,
                    index: rule.methodList.length,
                    
                    rate: BigNumber(method.rate),
                    
                    value: [
                      convert.toBigNumber(method.value?.[0]),
                      convert.toBigNumber(method.value?.[1], paymentInfo.value)
                    ],
                    
                    balance:
                      'balance' in method
                        ? convert.toBigNumber(method.balance)
                        : null,
                    
                    paymentState: {
                      errorMessage: [null, null],
                      comission: ZERO,
                      currency: [paymentInfo.currency, method.currency],
                      value: [ZERO, ZERO],
                      input: ['', ''],
                      adornment: [
                        priceFormat(
                          0.0,
                          paymentInfo.currency,
                          'string'
                        ).replace(/\s*0\s*/, ''),
                        priceFormat(0.0, method.currency, 'string').replace(
                          /\s*0\s*/,
                          ''
                        )
                      ]
                    }
                  };
                  
                  methodItem.calcValue = methodItem.value;
                  
                  rule.methodList.push(methodItem);
                  
                  scenario.methodQueue.push(methodItem);
                  
                  used.add(method.id);
                });
                
                return rule;
              });
              
              scenario.rules.forEach((ruleItem) => {
                const sum = scenario.rules.reduce(
                  (result, item) =>
                    item === ruleItem ? result : result.plus(item.value[0]),
                  ZERO
                );
                
                ruleItem.methodList.forEach(
                  (methodItem) =>
                    (methodItem.value[1] = BigNumber.min(
                      methodItem.value[1],
                      ruleItem.value[1],
                      paymentInfo.value.minus(sum)
                    ))
                );
              });
              
              if (scenario.rules[0].methodList.length) {
                this.setPaymentValue(
                  scenario,
                  scenario.rules[0].methodList[0],
                  0,
                  scenario.rules[0].value[1],
                  true
                );
                this.buildPaymentValue(
                  paymentInfo,
                  scenario,
                  scenario.rules[0].methodList[0],
                  false
                );
              }
              
              return scenario;
            });
        }
        
        paymentInfo.scenario = paymentInfo.scenarios?.length
          ? paymentInfo.scenarios[0]
          : null;
        
        setPaymentInfo(() => paymentInfo);
      } catch (e) {
        console.error(e);
        
        setPaymentInfo(() => ({ document: { id: document }, error: e }));
      }
    };
    
    loadPaymentState = async () => {
      const {
        shop,
        site,
        request,
        visitor,
        
        apiRequest,
        apiGetClientTokenGenerate,
        apiGetClientVisitor
      } = this.context;
      
      try {
        const requestInfo = await apiRequest('money/payment/state', {
          shop,
          site,
          id: request
        });
        
        const token = await apiGetClientTokenGenerate();
        
        await Promise.all(
          requestInfo.queue.map(async (queue) => {
            if (queue.target && queue.target !== visitor.id) {
              queue.target = (
                await apiGetClientVisitor(queue.target, { token })
              )[queue.target];
            } else {
              queue.target = null;
            }
          })
        );
        
        this.setState((state) => ({ ...state, requestInfo }));
      } catch (e) {
        console.error(e);
        
        this.setState((state) => ({ ...state, requestInfo: { error: e } }));
      }
    };
    
    checkPaymentValue = (scenario, method) => {
      const { langString, priceFormat } = this.context;
      
      const value = method.paymentState.value;
      
      if (!value[0].isZero() && value[0].comparedTo(method.value[0]) < 0) {
        value[0] = method.value[0];
        value[1] = method.value[0].dividedBy(method.rate);
        
        method.paymentState.errorMessage[0] = langString('value.min').replace(
          '%',
          priceFormat(value[0], method.paymentState.currency[0], 'string')
        );
        method.paymentState.errorMessage[1] = langString('value.min').replace(
          '%',
          priceFormat(value[1], method.paymentState.currency[1], 'string')
        );
      } else if (value[0].comparedTo(method.value[1]) > 0) {
        value[0] = method.value[1];
        value[1] = method.value[1].dividedBy(method.rate);
        
        method.paymentState.errorMessage[0] = langString('value.max').replace(
          '%',
          priceFormat(value[0], method.paymentState.currency[0], 'string')
        );
        method.paymentState.errorMessage[1] = langString('value.max').replace(
          '%',
          priceFormat(value[1], method.paymentState.currency[1], 'string')
        );
      } else {
        method.paymentState.errorMessage[0] =
          method.paymentState.errorMessage[1] = null;
      }
    };
    
    setPaymentValue = (scenario, method, input, value, normolize) => {
      const { langString, priceRound, priceFormat } = this.context;
      
      const input2 = input ? 0 : 1;
      
      if (BigNumber.isBigNumber(value)) {
        value = priceFormat(
          value,
          method.paymentState.currency[input],
          'simple'
        );
      } else {
        value = toPriceValue(value);
      }
      
      let numberValue = priceRound(
        value || 0,
        method.paymentState.currency[input],
        input ? 'floor' : 'ceil'
      );
      
      const numberValueIsNaN = numberValue.isNaN();
      
      if (numberValueIsNaN) numberValue = ZERO;
      
      if (normolize && !input)
        numberValue = BigNumber.max(
          BigNumber.min(numberValue, method.value[1]),
          ZERO
        );
      
      let numberValue2 = priceRound(
        input
          ? numberValue.multipliedBy(method.rate)
          : numberValue.dividedBy(method.rate),
        method.paymentState.currency[input2],
        input ? 'ceil' : 'floor'
      );
      
      if (!input) {
        numberValue = priceRound(
          numberValue2.multipliedBy(method.rate),
          method.paymentState.currency[0],
          'ceil'
        );
      } else {
        if (normolize)
          numberValue2 = BigNumber.max(
            BigNumber.min(numberValue2, method.value[1]),
            ZERO
          );
      }
      
      method.paymentState.value[input] = numberValue;
      method.paymentState.value[input2] = numberValue2;
      
      if (numberValueIsNaN) {
        method.paymentState.errorMessage[0] =
          method.paymentState.errorMessage[1] = langString('value.bad');
      } else {
        this.checkPaymentValue(scenario, method);
      }
      
      method.paymentState.comission = !method.paymentState.value[1].isZero()
        ? method.paymentState.value[1]
            .multipliedBy(method.comission[0])
            .multipliedBy(HUNDREDTH)
            .plus(method.comission[1])
        : ZERO;
      
      if (normolize) {
        if (numberValue.isZero()) {
          value = '';
        } else {
          value = priceFormat(
            numberValue,
            method.paymentState.currency[input],
            'simple'
          );
        }
      }
      
      method.paymentState.input[input] = value;
      method.paymentState.input[input2] = numberValue.isZero()
        ? ''
        : priceFormat(
            numberValue2,
            method.paymentState.currency[input2],
            'simple'
          );
    };
    
    buildPaymentValue = (paymentInfo, scenario, method, sort) => {
      //console.log('<----------------------------------------------------------');
      
      // Перетащить текущий метод в начало списка
      
      if (sort)
        scenario.methodQueue = [
          method,
          ...scenario.methodQueue.filter((methodItem) => methodItem !== method)
        ];
      
      // Посчитать динамические ограничения методов
      
      const methodValue = method.paymentState.value[0];
      
      scenario.rules.forEach((ruleItem) => {
        ruleItem.ruleValue = [ruleItem.value[0], ruleItem.value[1]];
      });
      
      scenario.methodQueue.forEach((methodItem) => {
        methodItem.calcValue = [ZERO, methodItem.value[1]];
      });
      
      paymentInfo.goods?.forEach((goodsItem) => {
        goodsItem.paymentRest = goodsItem.value.multipliedBy(goodsItem.count);
      });
      
      // Применить динамические ограничения
      
      let restValue = paymentInfo.value;
      
      scenario.methodQueue.forEach((methodItem) => {
        const startMethodValue = methodItem.paymentState.value[0];
        
        const valueIsZero =
          startMethodValue.comparedTo(ZERO) <= 0 &&
          methodItem.rule.ruleValue[0].comparedTo(ZERO) <= 0;
        
        const goodsRest =
          paymentInfo.goods?.reduce(
            (result, goodsItem) =>
              goodsItem.methods.indexOf(methodItem.id) >= 0
                ? result.plus(goodsItem.paymentRest)
                : result,
            ZERO
          ) || ZERO;
        
        methodItem.calcValue[0] = valueIsZero ? ZERO : methodItem.value[0];
        methodItem.calcValue[1] = BigNumber.max(
          BigNumber.min(
            methodItem.value[1],
            goodsRest,
            methodItem.rule.ruleValue[1]
          ),
          methodItem.calcValue[0]
        );
        
        if (!valueIsZero && methodItem === method) {
          methodItem.calcValue[0] = BigNumber.max(
            methodItem.calcValue[0],
            startMethodValue
          );
          methodItem.calcValue[1] = BigNumber.min(
            methodItem.calcValue[1],
            startMethodValue
          );
        }
        
        // Убавить общие динамические ограничения
        
        restValue = restValue.minus(startMethodValue);
        
        // Убавить динамические ограничения текущего правила
        
        methodItem.rule.ruleValue[0] =
          methodItem.rule.ruleValue[0].minus(startMethodValue);
        methodItem.rule.ruleValue[1] =
          methodItem.rule.ruleValue[1].minus(startMethodValue);
        
        // Убавить товарные динамические ограничения
        
        let methodValueRest = startMethodValue;
        
        paymentInfo.goods?.forEach((goodsItem) => {
          if (methodValueRest.comparedTo(ZERO) <= 0) return;
          
          const restDifference = BigNumber.min(
            methodValueRest,
            goodsItem.paymentRest
          );
          
          goodsItem.paymentRest = goodsItem.paymentRest.minus(restDifference);
          methodValueRest = methodValueRest.minus(restDifference);
        });
      });
      
      // Выровнить значения
      
      const paymentValue =
        scenario.rules.reduce(
          (result, ruleItem) =>
            result.plus(
              ruleItem.methodList.reduce(
                (result, methodItem) =>
                  result.plus(methodItem.paymentState.value[0]),
                ZERO
              )
            ),
          ZERO
        ) || ZERO;
      
      restValue = paymentInfo.value.minus(paymentValue);
      
      scenario.methodQueue.forEach((methodItem) => {
        if (restValue.isZero()) return;
        
        //console.log('restValue[', methodItem.id, ']: ', restValue.toString());
        
        const startMethodValue = methodItem.paymentState.value[0];
        
        let methodValue = methodItem.paymentState.value[0];
        
        if (methodItem !== method) methodValue = methodValue.plus(restValue);
        
        methodValue = BigNumber.max(
          BigNumber.min(methodValue, methodItem.calcValue[1]),
          methodItem.calcValue[0]
        );
        
        if (methodItem !== method)
          this.setPaymentValue(scenario, methodItem, 0, methodValue, true);
        //methodItem.paymentState.value[0] = methodValue;
        
        restValue = restValue.minus(methodValue).plus(startMethodValue);
      });
      
      // Перетащить текущий метод ближе к концу очереди
      
      if (sort) {
        const list = scenario.methodQueue.filter(
          (methodItem) => methodItem !== method
        );
        
        let index = list.findIndex(
          (methodItem) =>
            methodItem !== method &&
            methodItem.paymentState.value[0].comparedTo(ZERO) <= 0
        );
        
        if (index < 0) index = list.length;
        
        list.splice(index, 0, method);
        
        scenario.methodQueue = list;
      }
      
      // Сверить значения правил
      
      if (sort)
        scenario.rules.forEach((ruleItem) =>
          this.normolizeRuleValue(paymentInfo, scenario, ruleItem, method)
        );
      
      //console.log('---------------------------------------------------------->');
    };
    
    normolizeRuleValue = (paymentInfo, scenario, rule, method) => {
      const startRuleValue = rule.methodList.reduce(
        (result, methodItem) => result.plus(methodItem.paymentState.value[0]),
        ZERO
      );
      
      const ruleRest = startRuleValue.minus(
        BigNumber.max(
          BigNumber.min(startRuleValue, rule.value[1]),
          rule.value[0]
        )
      );
      
      if (!ruleRest.isZero()) {
        //console.log('------- ruleRest: ', ruleRest.toString());
        
        const ruleMethod = scenario.methodQueue.find(
          (methodItem) => methodItem !== method && methodItem.rule === rule
        );
        
        if (ruleMethod) {
          this.setPaymentValue(
            scenario,
            ruleMethod,
            0,
            ruleMethod.paymentState.value[0].minus(ruleRest),
            false
          );
          this.setPaymentValue(
            scenario,
            ruleMethod,
            1,
            ruleMethod.paymentState.value[1],
            true
          );
          
          this.buildPaymentValue(paymentInfo, scenario, ruleMethod, false);
        }
      }
    };
    
    changePaymentValue = (scenario, method, input, value) => {
      const { setPaymentInfo } = this.props;
      
      const input2 = input ? 0 : 1;
      
      setPaymentInfo((paymentInfo) => {
        paymentInfo = { ...paymentInfo };
        
        this.setPaymentValue(scenario, method, input, value, false);
        this.buildPaymentValue(paymentInfo, scenario, method, true);
        
        return paymentInfo;
      });
    };
    
    normolizePaymentValues = (scenario, method, input) => {
      const { setPaymentInfo } = this.props;
      
      const input2 = input ? 0 : 1;
      
      setPaymentInfo((paymentInfo) => {
        paymentInfo = { ...paymentInfo };
        
        this.setPaymentValue(
          scenario,
          method,
          input,
          method.paymentState.value[input],
          true
        );
        this.setPaymentValue(
          scenario,
          method,
          input2,
          method.paymentState.value[input2],
          true
        );
        
        const ruleMethod = scenario.methodQueue.find(
          (methodItem) =>
            methodItem !== method && methodItem.rule === method.rule
        );
        
        if (ruleMethod)
          this.normolizeRuleValue(
            paymentInfo,
            scenario,
            method.rule,
            ruleMethod
          );
        
        return paymentInfo;
      });
    };
    
    compareDocumentIds = (ids1, ids2) => {
      if (ids1 === ids2 || (!ids1 && !ids2)) return true;
      
      if (!ids1 || !ids2 || ids1.length !== ids2.length) return false;
      
      return ids1.every((id) => ids2.indexOf(id) >= 0);
    };
    
    renderPaymentNote = (data) => {
      if (!data.company?.nds)
        return data.note;
      
      const { langString } = this.context;
      
      const nds = Number(data.company.nds);
      
      return data.note + ', ' + (Number.isNaN(nds) ? langString('payment.nds.no') : langString('payment.nds').replace('{nds}', nds));
    };
    
    renderPaymentInput = (scenario, method, input, color, disabled) => {
      const {
        classes,
        
        paymentInfo
      } = this.props;
      
      const { langString } = this.context;
      
      if (input && paymentInfo.currency === method.currency) return '';
      
      return (
        <TextInput
          disabled={disabled || this.state.submit}
          label={!input ? langString('payment.amount') : null}
          isError={method.paymentState.errorMessage[input]}
          note={method.paymentState.errorMessage[input]}
          value={method.paymentState.input[input]}
          color={color}
          onChange={(event) =>
            this.changePaymentValue(scenario, method, input, event.target.value)
          }
          onBlur={(event) =>
            this.normolizePaymentValues(scenario, method, input)
          }
          startAdornment={
            <div className={classes.currencyAdornment}>
              <Text
                variant={
                  method.paymentState.errorMessage[0] ? 'invert' : 'normal'
                }
                color={method.paymentState.errorMessage[0] ? 'danger' : 'basic'}
              >
                {method.paymentState.adornment[input]}
              </Text>
            </div>
          }
        />
      );
    };
    
    renderDocumentInfo = () => {
      const {
        classes,
        
        paymentInfo
      } = this.props;
      
      const { langString, priceFormat } = this.context;
      
      const { requestInfo, error } = this.state;
      
      const info = paymentInfo || requestInfo;
      
      return (
        <>
          {!info || (info.document && !info.error) ? (
            <Card>
              <Grid container align="end">
                <Grid>
                  <Text strong color="hint" size="lg">
                    {langString('goods.count')}:
                  </Text>
                </Grid>
                <Grid align="end">
                  <Text strong color="hint" size="xl" align="right">
                    {info ? (
                      info.document.count
                    ) : (
                      <Skeleton className={classes.preliminarySkeleton} />
                    )}
                  </Text>
                </Grid>
              </Grid>
              
              <Grid container align="end">
                <Grid>
                  <Text strong color="hint" size="lg">
                    {langString('amount.for')}:
                  </Text>
                </Grid>
                <Grid align="end">
                  <Text strong color="hint" size="xl" align="right">
                    {info ? (
                      priceFormat(info.document.price, info.currency)
                    ) : (
                      <Skeleton className={classes.preliminarySkeleton} />
                    )}
                  </Text>
                </Grid>
              </Grid>
              
              <Grid container align="end">
                <Grid>
                  <Text strong color="hint" size="lg">
                    {langString('delivery.price')}:
                  </Text>
                </Grid>
                <Grid align="end">
                  <Text strong color="hint" size="xl" align="right">
                    {info ? (
                      priceFormat(info.document.delivery, info.currency)
                    ) : (
                      <Skeleton className={classes.preliminarySkeleton} />
                    )}
                  </Text>
                </Grid>
              </Grid>
              
              <Grid container align="end">
                <Grid>
                  <Text strong color="hint" size="lg">
                    {langString('discount')}:
                  </Text>
                </Grid>
                <Grid align="end">
                  <Text strong color="hint" size="xl" align="right">
                    {info ? (
                      priceFormat(info.document.discount, info.currency)
                    ) : (
                      <Skeleton className={classes.preliminarySkeleton} />
                    )}
                  </Text>
                </Grid>
              </Grid>
              
              {info && info.paid && !info.paid.isZero() ? (
                <Grid container align="end">
                  <Grid>
                    <Text strong color="hint" size="lg">
                      {langString('payment.paid')}:
                    </Text>
                  </Grid>
                  <Grid align="end">
                    <Text strong color="hint" size="xl" align="right">
                      {priceFormat(info.paid, info.currency)}
                    </Text>
                  </Grid>
                </Grid>
              ) : null}
              
              {info?.group_order?.targets?.map((target) => {
                const fullname = math.getFullname(target.info);
                
                return (
                  <Grid container align="end">
                    <Grid>
                      <Text strong color="hint" size="lg">
                        {
                          <>
                            {target.info.login}
                            {fullname ? <>&nbsp;({fullname})</> : null}
                          </>
                        }
                        :
                      </Text>
                    </Grid>
                    <Grid align="end">
                      <Text strong color="hint" size="xl" align="right">
                        {priceFormat(target.payment, target.currency)}
                      </Text>
                    </Grid>
                  </Grid>
                );
              })}
              
              <Grid container>
                <Grid>
                  <Divider />
                </Grid>
              </Grid>
              
              <Grid container align="end">
                <Grid>
                  <Text strong color="hint" size="xl">
                    {langString('amount')}:
                  </Text>
                </Grid>
                <Grid align="end">
                  <Text strong size="xl2" align="right">
                    {info ? (
                      priceFormat(info.value, info.currency)
                    ) : (
                      <Skeleton className={classes.preliminarySkeleton} />
                    )}
                  </Text>
                </Grid>
              </Grid>
            </Card>
          ) : null}
          
          {error ? <Card color="danger">{error.message}</Card> : null}
        </>
      );
    };
    
    renderDocumentPayment = () => {
      const {
        paymentInfo,
        setPaymentInfo,
        
        onAgreementShow
      } = this.props;
      
      const {
        shop,
        site,
        currency,
        documents,
        
        langString,
        priceFormat,
        apiRequest,
        
        isSmall
      } = this.context;
      
      if (paymentInfo === undefined || paymentInfo && !this.compareDocumentIds(paymentInfo?.document?.ids, documents)) {
        setTimeout(
          () =>
            setPaymentInfo((paymentInfo) => {
              if (paymentInfo !== undefined && (!paymentInfo || this.compareDocumentIds(paymentInfo?.document?.ids, documents)))
                return paymentInfo;
              
              this.loadPaymentInfo();

              return null;
            }),
          1
        );
      }
      
      const { submit } = this.state;
      
      const paymentValue =
        paymentInfo?.scenario?.rules.reduce(
          (result, ruleItem) =>
            result.plus(
              ruleItem.methodList.reduce(
                (result, methodItem) =>
                  result.plus(methodItem.paymentState.value[0]),
                ZERO
              )
            ),
          ZERO
        ) || ZERO;
      
      if (paymentInfo && !this.state.agreementsArticles) 
        this.state.agreementsArticles = paymentInfo.agreements?.articles || [];
      
      if (paymentInfo && !this.state.agreementsGoods) 
        this.state.agreementsGoods = paymentInfo.agreements?.goods || [];
      
      const nextDisabled =
        submit ||
        !paymentInfo?.scenario?.rules?.length ||
        paymentValue.comparedTo(paymentInfo.value) ||
        this.state.agreementsGoods?.some((agreement) => !agreement.checked);
      
      return (
        <Query
          rightChildren={
            <>
              {this.renderDocumentInfo()}
              
              {/*<div>
                <div>Rules values:</div>
                
                <div>
                  {paymentInfo?.scenario?.rules.map((ruleItem) => {
                    const value = ruleItem.methodList.reduce((result, methodItem) => result.plus(methodItem.paymentState.value[0]), ZERO);
                    const error = value.comparedTo(ruleItem.value[0]) < 0 || value.comparedTo(ruleItem.value[1]) > 0;
                    
                    return (
                      <div key={ruleItem.id}>
                        !{ruleItem.id}:[
                          <Text variant={error ? 'invert' : 'normal'} color={error ? 'danger' : 'basic'}>{value.toString()}</Text>
                          
                          &nbsp;/&nbsp;
                          
                          {ruleItem.value[0].toString()}
                          &nbsp;:&nbsp;
                          {ruleItem.value[1].toString()}
                        ]!
                      </div>
                    );
                  })}
                </div>
                
                <div>
                  ![{paymentValue.toString()}]!
                </div>
              </div>*/}
              
              {/*<div>
                <div>Methods values:</div>
                
                <div>
                  {paymentInfo?.scenario?.methodQueue.map((methodItem, index) => (
                    <div key={index}>
                      {index + 1}.&nbsp;
                      
                      {methodItem.id}
                      
                      &nbsp;/&nbsp;
                      
                      {methodItem.calcValue[0].toString()}
                      &nbsp;:&nbsp;
                      {methodItem.calcValue[1].toString()}
                      
                      &nbsp;-&nbsp;
                      {methodItem.methodValue?.toString() || 0}
                    </div>
                  ))}
                </div>
              </div>*/}
              
              <AgreementList
                agreements={this.state.agreementsArticles}
                onAgreementShow={onAgreementShow}
              />
              
              <AgreementList
                agreements={this.state.agreementsGoods}
                setChecked={(index, checked) => {
                  this.setState((state) => {
                    state = { ...state, agreementsGoods: [...state.agreementsGoods] };
                    
                    state.agreementsGoods[index].checked = checked;
                    
                    return state;
                  });
                }}
                onAgreementShow={onAgreementShow}
              />
              
              <Button
                disabled={nextDisabled}
                variant="contained"
                onClick={(event) => !nextDisabled && this.paymentRequest()}
              >
                {langString('payment.order')}
              </Button>
            </>
          }
        >
          <Grid container>
            <Grid>
              {!paymentInfo ? (
                <Card variant="bordered">
                  <Checkbox disabled>
                    <Text strong>
                      <Skeleton />
                    </Text>
                    <Text size="sm">
                      <Skeleton />
                    </Text>
                    <Text size="sm">
                      <Skeleton />
                    </Text>
                  </Checkbox>
                </Card>
              ) : paymentInfo.error ? (
                <Grid container>
                  <Grid align="center">
                    {paymentInfo.error.code === 'data-not-found' ? (
                      <Text color="hint" size="lg">
                        {langString('document.nfound').replace(
                          '%',
                          documents.join(', ')
                        )}
                      </Text>
                    ) : paymentInfo.error.code === 'data-wrong' ? (
                      <Text color="hint" size="lg">
                        {langString('document.paid').replace(
                          '%',
                          documents.join(', ')
                        )}
                      </Text>
                    ) : (
                      <Text variant="invert" color="danger" size="lg">
                        {paymentInfo.error.message}
                      </Text>
                    )}
                  </Grid>
                </Grid>
              ) : !paymentInfo.scenarios?.length ? (
                <Grid container>
                  <Grid align="center">
                    <Text size="lg">
                      {langString('payment.scenario.empty')}
                    </Text>
                  </Grid>
                </Grid>
              ) : !paymentInfo.methods?.length ? (
                <Grid container>
                  <Grid align="center">
                    <Text size="lg">{langString('payment.method.empty')}</Text>
                  </Grid>
                </Grid>
              ) : (
                <>
                  {paymentInfo.scenarios?.map(
                    (item, index) =>
                      index > 0 && this.renderDocumentPaymentScenario(item)
                  )}
                  
                  {paymentInfo?.scenario?.rules?.flatMap((rule) =>
                    rule.methodList.map((method) =>
                      this.renderDocumentPaymentMethod(
                        paymentInfo.scenario,
                        method
                      )
                    )
                  )}
                  
                  {/*paymentInfo.scenario?.rules?.length ? (
                    <Button disabled={submit} variant="outlined" onClick={(event) => null}>
                      {langString('payment.method.add')}
                    </Button>
                  ) : null*/}
                </>
              )}
            </Grid>
          </Grid>
        </Query>
      );
    };
    
    renderDocumentPaymentScenario = (item) => {
      const { paymentInfo, setPaymentInfo } = this.props;
      
      const disabled = !item.rules.some((rule, index) =>
        /*(item.rules.length === 1 || index < item.rules.length - 1) &&*/ rule.methodList.some(
          (method) =>
            method.value[1].comparedTo(ZERO) > 0 &&
            method.value[1].comparedTo(method.value[0]) >= 0
        )
      );
      
      const color = disabled
        ? 'hint'
        : paymentInfo.scenario?.id === item.id
        ? 'secondary'
        : 'basic';
      
      return (
        <Card key={item.id} variant="bordered" color={color}>
          <Checkbox
            disabled={disabled}
            checked={paymentInfo.scenario?.id === item.id}
            onChange={(event) => {
              const checked = event.target.checked;
              
              setPaymentInfo((paymentInfo) => ({
                ...paymentInfo,
                scenario: checked ? item : paymentInfo.scenarios[0] || null
              }));
            }}
          >
            <Text strong color={color}>
              {item.title}
            </Text>
            <Text size="sm" color={color}>
              {item.description}
            </Text>
          </Checkbox>
        </Card>
      );
    };
    
    renderDocumentPaymentMethod = (scenario, method) => {
      const {
        langString,
        priceFormat,
        
        isSmall
      } = this.context;
      
      const disabled =
        method.value[1].comparedTo(ZERO) <= 0 ||
        method.value[1].comparedTo(method.value[0]) < 0;
      const color = disabled
        ? 'hint'
        : method.paymentState.value[0].comparedTo(ZERO) > 0
        ? 'secondary'
        : 'basic';
      
      return (
        <Card key={method.id} variant="bordered" color={color}>
          <Grid container>
            <Grid>
              <Grid container>
                <Grid grow={1}>
                  <Text strong color={color}>
                    {method.title}
                    {/* !({method.id})*/}
                  </Text>
                </Grid>
                {method.image ? (
                  <Grid grow={0}>
                    <Logo variant="right" src={method.image} />
                  </Grid>
                ) : null}
              </Grid>
              
              {method.balance ? (
                <Grid container>
                  <Grid>
                    <TextInput
                      readOnly
                      label={langString('balance')}
                      value={priceFormat(
                        method.balance,
                        method.currency,
                        'string'
                      )}
                      color={color}
                    />
                  </Grid>
                </Grid>
              ) : null}
              
              {isSmall ? (
                <>
                  {this.renderPaymentInput(
                    scenario,
                    method,
                    0,
                    color,
                    disabled
                  )}
                  {this.renderPaymentInput(
                    scenario,
                    method,
                    1,
                    color,
                    disabled
                  )}
                </>
              ) : (
                <Grid container>
                  <Grid>
                    {this.renderPaymentInput(
                      scenario,
                      method,
                      0,
                      color,
                      disabled
                    )}
                  </Grid>
                  
                  <Grid>
                    {this.renderPaymentInput(
                      scenario,
                      method,
                      1,
                      color,
                      disabled
                    )}
                  </Grid>
                </Grid>
              )}
              
              {!method.paymentState.comission.isZero() ? (
                <Text size="xs2" color="hint">
                  {langString('comission')}:{' '}
                  {priceFormat(method.paymentState.comission, method.currency)}
                </Text>
              ) : null}
            </Grid>
          </Grid>
        </Card>
      );
    };
    
    renderRequestQueue = () => {
      const {
        theme,
        print,
        onPrevPage
      } = this.props;
      
      const {
        shop,
        site,
        currency,
        request,
        requestIsError,
        
        langString,
        priceFormat,
        apiRequest,
        
        isSmall
      } = this.context;
      
      if (this.state.requestInfo === undefined) {
        this.state.requestInfo = null;
        
        this.loadPaymentState();
      }
      
      const { requestInfo, submit, error } = this.state;
      
      const requestProcess = requestInfo?.process;
      
      const isNextDisabled = submit || !requestInfo?.queue?.length;
      
      if (!isNextDisabled && !error && !requestIsError && !requestInfo.error && !this.state.startSent)
        setTimeout(this.startRequest, 1);
      
      return (
        <Query
          rightChildren={
            <>
              {requestProcess?.type === 'receipt' && requestProcess?.data?.qrcode?.content ? (
                <Card>
                  <Grid container>
                    <Grid>
                      <Text strong color="hint" size="lg">{langString('payment.qrcode')}:</Text>
                    </Grid>
                    <Grid align="end">
                      <QRCodeSVG
                        value={requestProcess.data.qrcode.content}
                        level="L"
                        size={200}
                        bgColor={theme.getColor('card', 'basic', 'value')}
                        fgColor={theme.getColor('card', 'primary', 'value')}
                        style={{ aspectRatio: 1, height: 'auto', minWidth: 175, maxWidth: '100%' }}
                      />
                    </Grid>
                  </Grid>
                </Card>
              ) : null}
              
              {this.renderDocumentInfo()}
              
              {requestProcess?.type === 'receipt' && requestProcess?.data?.print ? (
                <Button
                  variant="outlined"
                  onClick={(event) => print(requestProcess?.data?.print)}
                >
                  {langString('payment.print')}
                </Button>
              ) : null}
              
              {requestProcess?.type === 'receipt' ? (
                <Button
                  disabled={isNextDisabled}
                  variant="contained"
                  onClick={(event) => this.processRequest(requestProcess.id)}
                >
                  {langString('payment.confirm')}
                </Button>
              ) : (
                <Button
                  disabled={isNextDisabled}
                  variant="contained"
                  onClick={(event) => this.startRequest()}
                >
                  {langString('payment.proceed')}
                </Button>
              )}
            </>
          }
        >
          <Grid container>
            <Grid>
              {!requestInfo ? (
                <Card variant="bordered">
                  <Text strong>
                    <Skeleton />
                  </Text>
                  <Text size="sm">
                    <Skeleton />
                  </Text>
                  <Text size="sm">
                    <Skeleton />
                  </Text>
                </Card>
              ) : requestInfo.error ? (
                <Grid container>
                  <Grid align="center">
                    <Text color="hint" size="lg">
                      {langString('request.nfound').replace('%', request)}
                    </Text>
                  </Grid>
                </Grid>
              ) : (
                <>
                  {requestProcess?.data?.message ? (
                    <Card variant="bordered" color="info">
                      {requestProcess.data.message}
                    </Card>
                  ) : null}
                  
                  {requestInfo.queue?.map((queueItem) => {
                    const color =
                      queueItem.state === 'paid'
                        ? 'success'
                        : queueItem.state === 'confirmed'
                        ? 'hint'
                        : queueItem.id === requestProcess?.id
                        ? 'secondary'
                        : 'basic';
                    
                    const fullname =
                      queueItem.target && math.getFullname(queueItem.target);
                    
                    return (
                      <Card key={queueItem.id} variant="bordered" color={color}>
                        <Grid container>
                          <Grid>
                            <Grid container>
                              <Grid grow={1}>
                                <Text strong color={color}>
                                  {queueItem.title}
                                </Text>
                              </Grid>
                              {queueItem.image ? (
                                <Grid grow={0}>
                                  <Logo variant="right" src={queueItem.image} />
                                </Grid>
                              ) : null}
                            </Grid>
                            
                            {queueItem.target ? (
                              <TextInput
                                readOnly
                                color={color}
                                label={langString('payment.target')}
                                value={
                                  queueItem.target.login +
                                  (fullname ? ' (' + fullname + ')' : '')
                                }
                              />
                            ) : null}
                            
                            {requestProcess?.type === 'receipt' && requestProcess?.data && requestProcess.id === queueItem.id ? (
                              <>
                                <TextInput
                                  readOnly
                                  color={color}
                                  label={langString('payment.date')}
                                  value={requestProcess.data.request.create_date}
                                />
                                
                                <TextInput
                                  readOnly
                                  color={color}
                                  label={langString('payment.expire')}
                                  value={requestProcess.data.request.expire_date}
                                />
                                
                                <TextInput
                                  readOnly
                                  color={color}
                                  label={langString('payment.amount')}
                                  value={priceFormat(
                                    queueItem.amount,
                                    queueItem.currency,
                                    'string'
                                  )}
                                />
                                
                                {requestProcess.data.note ? (
                                  <TextInput
                                    readOnly
                                    color={color}
                                    label={langString('payment.note')}
                                    value={this.renderPaymentNote(requestProcess.data)}
                                  />
                                ) : null}
                                
                                {requestProcess.data.type === 'quick' ? (
                                  <>
                                    {requestProcess.data.account ? (
                                      <TextInput
                                        readOnly
                                        color={color}
                                        label={langString('payment.account')}
                                        value={requestProcess.data.account}
                                      />
                                    ) : null}
                                  </>
                                ) : (
                                  <>
                                    <TextInput
                                      readOnly
                                      color={color}
                                      label={langString(requestProcess.data.type === 'rus' ? 'payment.company.name.rus' : 'payment.company.name')}
                                      value={requestProcess.data.company.name}
                                    />
                                    
                                    {requestProcess.data.company.inn ? (
                                      <TextInput
                                        readOnly
                                        color={color}
                                        label={langString('payment.company.inn')}
                                        value={requestProcess.data.company.inn}
                                      />
                                    ) : null}
                                    
                                    {requestProcess.data.company.kpp ? (
                                      <TextInput
                                        readOnly
                                        color={color}
                                        label={langString('payment.company.kpp')}
                                        value={requestProcess.data.company.kpp}
                                      />
                                    ) : null}
                                    
                                    <TextInput
                                      readOnly
                                      color={color}
                                      label={langString('payment.company.account.' + requestProcess.data.type)}
                                      value={requestProcess.data.company.account}
                                    />
                                    
                                    <TextInput
                                      readOnly
                                      color={color}
                                      label={langString('payment.bank.name.' + requestProcess.data.type)}
                                      value={requestProcess.data.bank.name}
                                    />
                                    
                                    {requestProcess.data.bank.address ? (
                                      <TextInput
                                        readOnly
                                        color={color}
                                        label={langString('payment.bank.address.' + requestProcess.data.type)}
                                        value={requestProcess.data.bank.address}
                                      />
                                    ) : null}
                                    
                                    {requestProcess.data.bank.swift ? (
                                      <TextInput
                                        readOnly
                                        color={color}
                                        label={langString('payment.bank.swift.' + requestProcess.data.type)}
                                        value={requestProcess.data.bank.swift}
                                      />
                                    ) : null}
                                    
                                    <TextInput
                                      readOnly
                                      color={color}
                                      label={langString('payment.bank.account.' + requestProcess.data.type)}
                                      value={requestProcess.data.bank.account}
                                    />
                                    
                                    {requestProcess.data.bank.bic ? (
                                      <TextInput
                                        readOnly
                                        color={color}
                                        label={langString('payment.bank.bic')}
                                        value={requestProcess.data.bank.bic}
                                      />
                                    ) : null}
                                    
                                    {requestProcess.data.agent?.name ? (
                                      <TextInput
                                        readOnly
                                        color={color}
                                        label={langString('payment.agent.name.' + requestProcess.data.type)}
                                        value={requestProcess.data.agent.name}
                                      />
                                    ) : null}
                                    
                                    {requestProcess.data.agent?.swift ? (
                                      <TextInput
                                        readOnly
                                        color={color}
                                        label={langString('payment.agent.swift.' + requestProcess.data.type)}
                                        value={requestProcess.data.agent.swift}
                                      />
                                    ) : null}
                                  </>
                                )}
                              </>
                            ) : (
                              <TextInput
                                readOnly
                                color={color}
                                label={langString('payment.amount')}
                                value={priceFormat(
                                  queueItem.amount,
                                  queueItem.currency,
                                  'string'
                                )}
                              />
                            )}
                            
                            {requestProcess?.type === 'voucher' ? (
                              <>
                                <NumberFormat
                                  displayType="input"
                                  customInput={TextInput}
                                  format={VOUCHER_MASK}
                                  valueIsNumericString
                                  color={color}
                                  label={langString('payment.voucher')}
                                  value={this.state.data?.voucher}
                                  onChange={(event) => {
                                    const voucher = event.target.value;
                                    
                                    this.setState((state) => ({ ...state, data: { ...state.data, voucher } }));
                                  }}
                                />
                              </>
                            ) : null}
                          </Grid>
                        </Grid>
                      </Card>
                    );
                  })}
                </>
              )}
              
              <Button variant="outlined" onClick={(event) => onPrevPage()}>
                {langString('payment.method.another')}
              </Button>
            </Grid>
          </Grid>
        </Query>
      );
    };
    
    renderProtectionData = () => {
      const {
        shop,
        site,
        currency,
        request,
        
        langString,
        apiRequest,
        
        isSmall
      } = this.context;
      
      const { requestInfo, protectionData, submit, error } = this.state;
      
      return (
        <Query
          rightChildren={
            <>
              {this.renderDocumentInfo()}
              
              <Button
                disabled={
                  submit ||
                  !requestInfo.queue?.length ||
                  !this.state.protectionValue
                }
                variant="contained"
                onClick={(event) => this.processRequest()}
              >
                {langString('confirm')}
              </Button>
            </>
          }
        >
          <Grid container>
            <Grid>
              <Card variant="bordered">
                <Grid container>
                  <Grid>
                    <Text strong>{langString('security.required')}</Text>
                    
                    {protectionData.mode === 'passwd' ? (
                      <>
                        <Text>{langString('security.passwd.enter')}</Text>
                        
                        <TextInput
                          type="password"
                          label={langString('passwd')}
                          value={this.state.protectionValue}
                          onChange={(event) => {
                            const value = event.target.value;
                            this.setState((state) => ({
                              ...state,
                              protectionValue: value
                            }));
                          }}
                        />
                      </>
                    ) : protectionData.mode === 'finpasswd' ? (
                      <>
                        <Text>{langString('security.finpasswd.enter')}</Text>
                        
                        <TextInput
                          type="password"
                          label={langString('finpasswd')}
                          value={this.state.protectionValue}
                          onChange={(event) => {
                            const value = event.target.value;
                            this.setState((state) => ({
                              ...state,
                              protectionValue: value
                            }));
                          }}
                        />
                      </>
                    ) : protectionData.mode === 'gauth' ? (
                      <>
                        <Text>{langString('security.gauth.enter')}</Text>
                        
                        <TextInput
                          label={langString('code')}
                          value={this.state.protectionValue}
                          onChange={(event) => {
                            const value = event.target.value;
                            this.setState((state) => ({
                              ...state,
                              protectionValue: value
                            }));
                          }}
                        />
                      </>
                    ) : protectionData.mode === 'sms' ? (
                      <>
                        <Text>{langString('security.sms.enter')}</Text>
                        
                        <TextInput
                          label={langString('code')}
                          value={this.state.protectionValue}
                          onChange={(event) => {
                            const value = event.target.value;
                            this.setState((state) => ({
                              ...state,
                              protectionValue: value
                            }));
                          }}
                        />
                      </>
                    ) : protectionData.mode === 'fcall' ? (
                      <>
                        <Text>{langString('security.fcall.enter')}</Text>
                        
                        <TextInput
                          label={langString('code')}
                          value={this.state.protectionValue}
                          onChange={(event) => {
                            const value = event.target.value;
                            this.setState((state) => ({
                              ...state,
                              protectionValue: value
                            }));
                          }}
                        />
                      </>
                    ) : protectionData.mode === 'email' ? (
                      <>
                        <Text>{langString('security.email.enter')}</Text>
                        
                        <TextInput
                          label={langString('code')}
                          value={this.state.protectionValue}
                          onChange={(event) => {
                            const value = event.target.value;
                            this.setState((state) => ({
                              ...state,
                              protectionValue: value
                            }));
                          }}
                        />
                      </>
                    ) : (
                      <Text variant="invert" color="danger">
                        {langString('security.method.unknown')}
                      </Text>
                    )}
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Query>
      );
    };
    
    componentDidMount() {}
    
    componentWillUnmount() {}
    
    componentDidUpdate(prevProps, prevState, snapshot) {}
    
    render() {
      if (this.context.request) {
        if (this.state.requestInfo && this.state.protectionData) {
          return this.renderProtectionData();
        } else {
          return this.renderRequestQueue();
        }
      } else {
        return this.renderDocumentPayment();
      }
    }
  }
);

const toPriceValue = (value) => {
  value = String(value || '')
    .replace(/[^\d\.,бю]/g, '')
    .replace(/[,бю]/g, '.');
  
  const firstIndex = value.indexOf('.');
  
  if (firstIndex >= 0) {
    while (true) {
      const lastIndex = value.lastIndexOf('.');
      
      if (firstIndex === lastIndex) break;
      
      value = value.substring(0, lastIndex) + value.substring(lastIndex + 1);
    }
  }
  
  return value;
};
